/*
  dr-accordion.js
  Drives every [data-dr-accordion]. Each trigger toggles the panel that follows
  it. Set data-dr-accordion="single" on the wrapper to close siblings on open.
*/
(function () {
  function initAccordion(root) {
    if (root.dataset.drInit) return;
    root.dataset.drInit = 'true';

    const single = root.dataset.drAccordion === 'single';
    const triggers = Array.from(root.querySelectorAll('[data-dr-accordion-trigger]'));

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (single && !expanded) {
          triggers.forEach((other) => {
            if (other === trigger) return;
            other.setAttribute('aria-expanded', 'false');
            const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
            if (otherPanel) otherPanel.hidden = true;
          });
        }

        trigger.setAttribute('aria-expanded', String(!expanded));
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (panel) panel.hidden = expanded;
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-dr-accordion]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
